export const STORAGE_URLS = {
    LITE: 'video/lite',
    SCOUT: 'video/scout'
};

export const BLOB_URL = 'https://icebergvideo.blob.core.windows.net';
export const CDN_URL = 'https://fast.cdn.tpeteam.com';
